module.exports = __webpack_public_path__ + "img/csi-page-tabs-image-3.e7f51b47.jpg";